import { Oval } from 'react-loader-spinner';

interface LoaderProps {
  message?: string;
  loading: boolean;
}

export default function Loader({
  message = 'Loading application...',
  loading,
}: LoaderProps) {
  if (!loading) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white">
      <div className="flex flex-col items-center">
        <Oval
          height={48}
          width={48}
          color="#f97316"
          secondaryColor="#e5e7eb"
          strokeWidth={4}
          ariaLabel="Loading"
          visible={true}
        />
        <p className="mt-4 text-gray-700">{message}</p>
      </div>
    </div>
  );
}
